module.exports = __webpack_public_path__ + "img/traitement1.1d8c0509.jpg";